/**
 * APIエンドポイント定数
 *
 * バックエンドAPIのエンドポイントパスを定義します。
 */
/** 認証エンドポイント */
export const AUTH_ENDPOINTS = {
    /** ログイン */
    LOGIN: "/auth/login",
    /** ログアウト */
    LOGOUT: "/auth/logout",
    /** トークンリフレッシュ */
    REFRESH: "/auth/refresh",
    /** トークン検証 */
    VERIFY: "/auth/verify",
};
/** システムエンドポイント */
export const SYSTEM_ENDPOINTS = {
    /** ヘルスチェック */
    HEALTH: "/health",
    /** JWKS公開鍵 */
    JWKS: "/.well-known/jwks.json",
};
/** 全エンドポイント */
export const ENDPOINTS = {
    ...AUTH_ENDPOINTS,
    ...SYSTEM_ENDPOINTS,
};
//# sourceMappingURL=endpoints.js.map